import { ReactNode } from "react";
import { Link } from "react-router-dom";
import "./PageHeader.css";

interface PageHeaderProps {
	title: ReactNode;
	subtitle?: ReactNode;
	/** Rendered on the right, typically the live badge or week navigation. */
	aside?: ReactNode;
	/** Where the title links back to, for detail screens. */
	backTo?: string;
}

export const PageHeader = ({ title, subtitle, aside, backTo }: PageHeaderProps) => (
	<header className="page-header">
		<div className="page-header-text">
			<div className="page-header-eyebrow">
				<span className="eyebrow">Bullen·Stats</span>
				<Link to="/settings" className="page-header-settings" aria-label="Settings">
					<i className="ri-settings-3-line" />
				</Link>
			</div>
			<h1 className="page-header-title">
				{backTo ? (
					<Link to={backTo} className="page-header-back">
						<i className="ri-arrow-left-line" /> {title}
					</Link>
				) : (
					title
				)}
			</h1>
			{subtitle && <p className="page-header-subtitle">{subtitle}</p>}
		</div>
		{aside && <div className="page-header-aside">{aside}</div>}
	</header>
);
